export const Checkmark = props => {
    return (
        <svg width={11} height={8} viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M9.5 1L4 7 1 4" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};
